var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"shopTraveler"},[_c('back-to'),_c('van-address-edit',{attrs:{"area-list":_vm.areaList,"address-info":_vm.AddressInfo},on:{"save":_vm.onSave}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }